import { AxiosResponse } from 'axios';
import api from './api';

// eslint-disable-next-line import/prefer-default-export
export const registerLog = async (payload: Services.LogsAction.Register): Promise<AxiosResponse> => api.post('logs', payload);
